import { render } from "./EmployeeDetails.vue?vue&type=template&id=36a33313"
import script from "./EmployeeDetails.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script